import get from 'lodash/get';

export default {
  loanAmount: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  annualGrossIncome: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  employmentStatus: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  employmentYears: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }
    },
  }],
  consentToVerifyIncomeEmployment: [
    'required',
    {
      isValid: (input) => (
        input || 'The custom field is not valid'
      ),
    },
  ],
};
